<mat-tab-group color="primary">
  <mat-tab label="Users">
    @if (userView() === TabView.List) {
      <app-admin-area-list
        (objectItemEvent)="openUserConfig($event)"
        [list]="userList()"
        [objectName]="'User'"></app-admin-area-list>
    }
    @if (userView() === TabView.Config && tools.value(); as tools) {
      <app-user-config
        [userId]="this.selectedUser()"
        (applyEvent)="closeConfig()"
        [tools]="tools"></app-user-config>
    }
  </mat-tab>
  <mat-tab label="Tools">
    @if (toolView() === TabView.List) {
      <app-admin-area-list
        (objectItemEvent)="openToolConfig($event)"
        [list]="toolList()"
        [objectName]="'Tool'"></app-admin-area-list>
    }
    @if (toolView() === TabView.Config) {
      <app-tool-config [toolId]="selectedTool()"></app-tool-config>
    }
    @if (toolView() === TabView.Installation) {
      <app-tool-installation></app-tool-installation>
    }
  </mat-tab>
  <mat-tab label="Toolchains">
    @if (toolchainView() === TabView.List) {
      <app-admin-area-list
        (objectItemEvent)="openToolchainConfig($event)"
        [list]="toolchainList()"
        [objectName]="'Toolchain'"></app-admin-area-list>
    }
    @if (toolchainView() === TabView.Config) {
      <app-toolchain-config [toolchainId]="selectedToolchain()"></app-toolchain-config>
    }
    @if (toolchainView() === TabView.Installation) {
      <app-toolchain-installation></app-toolchain-installation>
    }
  </mat-tab>
</mat-tab-group>
<div class="version">
  <div>Frontend Version: {{ hepVersionFrontend() }}</div>
  <div>Backend Version: {{ hepVersionBackend.value()?.version }}</div>
</div>
